export default __webpack_public_path__ + "static/media/1869.93240a50.png";